const callStates = {
  CONNECTED: 'connected',
  DISCONNECTING: 'disconnecting',
  CONNECTING: 'connecting',
};

export default callStates;
